<form [formGroup]="formulario">
  <div class="ps-form-data-field-container">
    <div class="ps-row" fxLayout="row">
      <div fxFlex>
        <p class="ps-description-14">
          Defina abaixo as configurações dos dados do campo.
        </p>
      </div>
    </div>
    <div class="ps-row" fxLayout="row">
      <div fxFlex fxLayoutGap="20px">
        <mat-radio-group
          (change)="changeDataType($event)"
          formControlName="data_type"
          fxLayoutGap="20px">
          <mat-radio-button
            class="ps-form-data-radio-button"
            value="1"
            color="primary">
            Valor padrão simples
            <mat-icon
              matTooltip="Marcando essa opção, insira variáveis no campo abaixo para defini-las como seu valor padrão."
              matTooltipPosition="after"
              matTooltipClass="ps-tooltip-preLined-content"
              svgIcon="help">
            </mat-icon>
          </mat-radio-button>
          <mat-radio-button
            class="ps-form-data-radio-button"
            value="2"
            color="primary">
            Valor padrão dinâmico
            <mat-icon
              matTooltip="Marcando essa opção, insira variáveis no campo abaixo, para que sejam enviadas pelos
              parâmetros da URL da página onde o campo se localiza."
              matTooltipPosition="after"
              matTooltipClass="ps-tooltip-preLined-content"
              svgIcon="help">
            </mat-icon>
          </mat-radio-button>
          <mat-radio-button
            class="ps-form-data-radio-button"
            value="3"
            color="primary">
            Fonte externa
          </mat-radio-button>
        </mat-radio-group>
        <a mat-stroked-button (click)="f.data_type.reset(null); f.data_value.reset(null);">Limpar</a>
      </div>
    </div>

    <div *ngIf="f.data_type.value !== '3'" class="ps-row" fxLayout="row">
      <div fxFlex>
        <mat-form-field appearance="fill" fxFlex="50">
          <mat-label>{{f.data_type.value === '1' ? 'Valor padrão': 'Nome do parâmetro'}}</mat-label>
          <input *ngIf="f.data_type.value !== '1' || currentForm.predefinedOption === undefined || (currentForm.predefinedOption === false) else elseBlock"
            [disableControl]="f.data_type.value"
            matInput
            required
            formControlName="data_value">
            <!-- valor padrão nos campos tipoSexo e logico -->
            <ng-template #elseBlock>
              <mat-select [disableControl]="f.data_type.value" formControlName="data_value" required>
                <mat-option *ngFor="let option of currentForm.values" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </ng-template>

            <mat-error *ngIf="f.data_value.hasError('required')">
              Campo obrigatório
            </mat-error>

            <mat-error *ngIf="f.data_value.hasError('reserved')">
              O parâmetro {{f.data_value.value}} não pode ser utilizado
            </mat-error>
          </mat-form-field>
      </div>
    </div>

    <div
      formGroupName="external_source"
      *ngIf="f.data_type.value === '3'"
      class="ps-row"
      fxLayout="column">
      <div fxLayout="row" fxLayoutGap="20px" >
        <div fxFlex="30">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>Tipo de envio</mat-label>
            <mat-select formControlName="http_methods_type_id" required>
              <mat-option
                [value]="item.id"
                *ngFor="let item of httpMethods">
                {{item.title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="50">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>Link</mat-label>
            <input matInput formControlName="link" required>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" style="margin: 15px 0;">
        <div fxFlex>
          <mat-slide-toggle
            color="primary"
            formControlName="auto_save">
            Salvar valor automaticamente
          </mat-slide-toggle>
        </div>
      </div>

      <div fxLayout="row">
        <app-adds-pareaments
          class="ps-edit-form-parameters-custom"
          fxFlex
          [toggle]="false"
          [systemFields]="systemFields"
          [parameters]="parameters"
          [formulario]="f.external_source">
        </app-adds-pareaments>
      </div>

      <div fxLayout="row">
        <span class="ps-expected-return">Retorno esperado</span>
      </div>
      <div fxLayout="row" [style.margin-bottom.px]="40">
        <td-code-editor
          class="monaco-editor-custom"
          [style.height.px]="57"
          [editorOptions]="{
            selectionHighlight: false,
            minimap: { enabled: false },
            scrollbar: { vertical: 'hidden' },
            readOnly: true,
            scrollPredominantAxis: false,
            scrollBeyondLastLine: false,
            scrollBeyondLastColumn: 0
          }"
          theme="vs-dark"
          language="json"
          [value]="value"
          fxFlex="60">
        </td-code-editor>
      </div>
    </div>
  </div>

  <div fxLayout="row">
    <div fxFlex>
      <mat-divider></mat-divider>
    </div>
  </div>

  <div class="ps-form-data-field-two-container" fxLayout="column">
    <div fxLayout="row" [style.margin-bottom.px]="f.defined_source.value === 2 || f.defined_source.value === 3 && f.predefined_source_options.value ? 35 : 0">
      <div fxFlex="30">
        <p class="ps-label-slide-toggle">Opções predefinidas</p>
        <mat-slide-toggle
          color="primary"
          formControlName="predefined_source_options">
          {{f.predefined_source_options.value ? 'Ativado' : 'Desativado'}}
        </mat-slide-toggle>
      </div>

      <div fxFlex *ngIf="f.predefined_source_options.value">
        <p class="ps-label-slide-toggle">Defina a fonte</p>
        <mat-radio-group
          (change)="changeDefinedSource($event)"
          formControlName="defined_source"
          fxLayoutGap="25px">
          <mat-radio-button
            [value]="1"
            color="primary">
            TOTVS
          </mat-radio-button>
          <mat-radio-button
            [value]="2"
            color="primary">
            Fonte externa
          </mat-radio-button>
          <mat-radio-button
            [value]="3"
            color="primary">
            Manual
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div
      formGroupName="predefined_external_source"
      *ngIf="f.defined_source.value === 2 && f.predefined_source_options.value"
      class="ps-row"
      fxLayout="column">
      <div fxLayout="row" fxLayoutGap="20px" class="ps-row">
        <div fxFlex="30">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>Tipo de envio</mat-label>
            <mat-select formControlName="http_methods_type_id" required>
              <mat-option
                [value]="item.id"
                *ngFor="let item of httpMethods">
                {{item.title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="50">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>Link</mat-label>
            <input matInput formControlName="link" required>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row">
        <app-adds-pareaments-secondary
          class="ps-edit-form-parameters-custom"
          fxFlex
          [toggle]="false"
          [systemFields]="systemFields"
          [parameters]="parametersTwo"
          [formulario]="f.predefined_external_source">
        </app-adds-pareaments-secondary>
      </div>

      <div fxLayout="row">
        <span class="ps-expected-return">Retorno esperado</span>
      </div>
      <div fxLayout="row" [style.margin-bottom.px]="40">
        <td-code-editor
          class="monaco-editor-custom"
          [style.height.px]="228"
          [editorOptions]="{
            selectionHighlight: false,
            minimap: { enabled: false },
            scrollbar: { vertical: 'hidden' },
            readOnly: true,
            scrollPredominantAxis: false,
            scrollBeyondLastLine: false,
            scrollBeyondLastColumn: 0
          }"
          theme="vs-dark"
          language="json"
          [value]="valueTwo"
          fxFlex="60">
        </td-code-editor>
      </div>
    </div>

    <div
    *ngIf="f.defined_source.value === 3 && f.predefined_source_options.value"
    fxLayout="column"
    >
    <div
      *ngFor="let value of manualValues; let i = index"
      formArrayName="manual_options"
      >
        <div fxLayout="row" fxLayoutGap="20px" class="ps-row" [formGroupName]="i">
            <div fxFlex="25">
              <mat-form-field appearance="fill" fxFlex>
                <mat-label>Valor</mat-label>
                <input matInput formControlName="value" required>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="fill" fxFlex>
                <mat-label>Texto</mat-label>
                <input matInput formControlName="display" required>
              </mat-form-field>
            </div>
            <div
            fxLayoutGap="15px"
            fxFlex="10" fxLayoutAlign="start center"
            class="ps-adds-pareaments-btn-content">
            <a
              *ngIf="!this.editorMode"
              class="ps-adds-pareaments-add"
              color="primary"
              mat-stroked-button
              (click)="addManualOption([],i)">
              <mat-icon>add</mat-icon>
            </a>
            <a
            *ngIf="manualValues.length > 1 && (!this.editorMode)"
            class="ps-adds-pareaments-del"
            color="primary"
            mat-stroked-button
            (click)="removeManualOption(i)">
            <mat-icon>delete</mat-icon>
          </a>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div fxLayout="row">
    <div fxFlex>
      <mat-divider></mat-divider>
    </div>

  </div>
  <div class="ps-form-data-field-three-container" fxLayout="row">
    <div fxFlex>
      <p class="ps-label-slide-toggle">Somente leitura</p>
      <mat-slide-toggle
        color="primary"
        formControlName="read_only">
        {{f.read_only.value ? 'Ativado' : 'Desativado'}}
      </mat-slide-toggle>
    </div>
  </div>
</form>
